<div class="modal-content">
    <div class="modal-header border-0">
        <h5 class="modal-title" id="modulesModalLabel">Cambiar Estatus</h5>
        <button type="button" class="btn-close" (click)="modal.dismissAll()"></button>
    </div>
    <div class="modal-body p-4">
        <form novalidate [formGroup]="changeStatusForm">
            <div class="mb-3">
                <label class="col-12 form-label m-0" for="assignment_status">Estatus <span class="txt-danger"> *</span></label>
                <select class="col-12 form-select" id="assignment_status" required formControlName="assignment_status"
                        [ngClass]="{ 'is-invalid' : (assignmentStatus?.touched || validate) && assignmentStatus?.errors, 'is-valid' : !assignmentStatus?.errors}">
                    <option *ngFor="let opt of filteredOptions" [value]="opt.value">{{ opt.label }}</option>
                </select>
                @if (assignmentStatus?.errors) {
                    <div class="invalid-feedback">Selecciona el estatus</div>
                }
            </div>
        </form>
    </div>
    <div class="modal-footer border-0 pt-3">
        <button type="button" class="btn btn-outline-secondary" (click)="modal.dismissAll()">Cerrar</button>
        <button type="button" class="btn btn-primary" (click)="sendForm()">Cambiar el status</button>
    </div>
</div>
